import React, { Children } from 'react'
import PropTypes from 'prop-types'

import { ListItem, ListItemText, Skeleton } from '@mui/material'

import NoteUserInfo from 'components/notes/common/NoteUserInfo'

const HistorySkeleton = ({ rows = 1 }) => {
  const shimmersArray = new Array(rows).fill()
  return Children.toArray(
    shimmersArray.map((_, index) => {
      const isLastRow = index === rows - 1
      return (
        <ListItem divider={!isLastRow}>
          <Skeleton variant="circular" width={32} height={32}>
            <NoteUserInfo firstName="" lastName="" />
          </Skeleton>
          <ListItemText
            primary={<Skeleton width="6rem" variant="text" />}
            secondary={<Skeleton width="12rem" variant="text" />}
            slotProps={{
              primary: { variant: 'h6', fontWeight: 400 },
            }}
          />
        </ListItem>
      )
    })
  )
}
HistorySkeleton.propTypes = {
  rows: PropTypes.number,
}

export default HistorySkeleton
